import typewriter from 'analytics/typewriter'
import { forOwn, snakeCase } from 'lodash'

export default {
  navSearchTermEntered,
  navSearchResultClicked,
  navSearchResultsEmpty
}

const getBasicProperties = properties => {
  const newProps = {}
  forOwn(properties, (val, key) => {
    newProps[snakeCase(key)] = val
  })
  return newProps
}

function navSearchTermEntered(properties) {
  const { workspaceId } = properties

  typewriter.navSearchTermEntered(getBasicProperties(properties), {
    context: {
      groupId: workspaceId
    }
  })
}

function navSearchResultClicked(properties) {
  const { workspaceId } = properties
  typewriter.navSearchResultClicked(getBasicProperties(properties), {
    context: {
      groupId: workspaceId
    }
  })
}

function navSearchResultsEmpty(properties) {
  const { workspaceId } = properties
  typewriter.navSearchResultsEmpty(getBasicProperties(properties), {
    context: {
      groupId: workspaceId
    }
  })
}
